module.exports = __webpack_public_path__ + "img/facebook-icon.86594260.png";